import React from 'react';
import { ListItem } from '@mui/material';
import { StyledNormalTypography } from '../../theme/StyledElements';
import { useNavigate } from 'react-router-dom';
import { SidebarListProps } from '../Sidebar';

export const SingleLevel = ({ item, path }: SidebarListProps): JSX.Element => {
    const navigate = useNavigate();
    const activePath = item.path.split('/')[1];
    return (
        <ListItem
            button
            sx={{
                justifyContent: 'left',
                minWidth: 'auto',
                backgroundColor: path === activePath && path !== 'add-basket' ? '#394A35' : '#FFFF',
                '&:hover': {
                    backgroundColor:
                        path === activePath && path !== 'add-basket' ? '#394A35' : '#FFFF',
                    color: '#FFFFFF'
                },
                borderRadius: '0px 20px 20px 0px'
            }}
            onClick={(): void => navigate(item.path)}>
            {item.icon}
            <StyledNormalTypography
                variant="subtitle2"
                color={path === activePath && path !== 'add-basket' ? '#FFFF' : item.color}
                sx={{ marginLeft: '10px' }}>
                {item.title}
            </StyledNormalTypography>
        </ListItem>
    );
};
